import { render } from "./OtherSurveys.vue?vue&type=template&id=3a2a7339"
import script from "./OtherSurveys.vue?vue&type=script&lang=js"
export * from "./OtherSurveys.vue?vue&type=script&lang=js"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__